import '../sass/test.scss'

function Test() {
	return (
		<div>
			<h2>INPUT, LINEAR GRADIENT</h2>
			<div className={'one'}>
				<div className={'one-one'}>
					<h1>Basic information</h1>
					<p>Full name</p>
					<input type={'text'} placeholder={'Nguyễn Văn A'}/>
					<p>Date of birth</p>
					<input type={'date'} placeholder={'Your birthday'}/>
					<p>Telephone</p>
					<input type={'number'} placeholder={'123456789'}/>
				</div>
			</div>
			<h3>TỔNG HỢP</h3>
			<div className={'two'}>
				<div className={'two-one'}>
					<img className={'img-background'} alt={'background'} src={'https://thumbs.dreamstime.com/b/landscape-nature-view-background-view-window-landscape-nature-view-background-view-window-wonderful-landscape-121459679.jpg'} />
					<div className={'two-two'}>
						<img className={'img-icon'} alt={'background'} src={"https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/2008px-Google_%22G%22_Logo.svg.png"}/>
						<div className={'two-three'}>
							<div className={'two-four'}>Title</div>
							<div className={'two-five'}>2023-04-27 08:08:08</div>
						</div>
					</div>
				</div>
				<div className={'two-one'}>
					<img className={'img-background'} alt={'background'} src={'https://thumbs.dreamstime.com/b/landscape-nature-view-background-view-window-landscape-nature-view-background-view-window-wonderful-landscape-121459679.jpg'} />
					<div className={'two-two'}>
						<img className={'img-icon'} alt={'background'} src={"https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/2008px-Google_%22G%22_Logo.svg.png"}/>
						<div className={'two-three'}>
							<div className={'two-four'}>Title</div>
							<div className={'two-five'}>2023-04-27 08:08:08</div>
						</div>
					</div>
				</div>
				<div className={'two-one'}>
					<img className={'img-background'} alt={'background'} src={'https://thumbs.dreamstime.com/b/landscape-nature-view-background-view-window-landscape-nature-view-background-view-window-wonderful-landscape-121459679.jpg'} />
					<div className={'two-two'}>
						<img className={'img-icon'} alt={'background'} src={"https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/Google_%22G%22_Logo.svg/2008px-Google_%22G%22_Logo.svg.png"}/>
						<div className={'two-three'}>
							<div className={'two-four'}>Title</div>
							<div className={'two-five'}>2023-04-27 08:08:08</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Test;
